// ======================================================================
// File Name       : configFile
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function postDownloadConfigFileResult(data) {
  return commonCallApi({
    path: 'userfront/DownloadResult',
    data,
  });
}

export function postDownloadConfigFile() {
  return commonCallApi({
    path: 'userfront/Download',
  });
}

export function postUploadConfigFileResult(data) {
  return commonCallApi({
    path: 'userfront/UploadResult',
    data,
  });
}

export function postUploadConfigFile(data) {
  return commonCallApi({
    path: 'userfront/Upload',
    data,
    muiltipart: 1,
  });
}
